import { useLocation } from '@tanstack/react-router'
import { machineHref } from '@/lib/machine-view'

// The HUMAN / MACHINE pill (OpenSpec 137): floats at the bottom centre of every public page, like
// parallel.ai/ai, next to the switch in the footer. Plain links (full page loads): /machine/* is
// served by the worker, not by the router. The dots are drawn from aria-current.
export function ViewPill() {
  const { pathname } = useLocation()
  const item = 'group flex items-center gap-2 px-3 py-2 uppercase tracking-wide transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
  const dot = 'size-2.5 rounded-full border border-current group-aria-[current=page]:bg-current'
  return (
    <div
      role="group"
      aria-label="Switch view"
      className="vt-pill fixed bottom-4 left-1/2 z-40 flex -translate-x-1/2 items-center rounded-md border border-border bg-foreground px-1 font-mono text-sm text-background shadow-raised print:hidden"
    >
      <a href={pathname} aria-current="page" className={`${item} opacity-100`}>
        <span aria-hidden="true" className={dot} />
        Human
      </a>
      <a href={machineHref(pathname)} className={`${item} opacity-70`}>
        <span aria-hidden="true" className={dot} />
        Machine
      </a>
    </div>
  )
}
